import * as ImagePicker from 'expo-image-picker';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Image } from 'react-native';
import { ListItem, ListOption } from '@/components/list-item';

const IMAGE_HEIGHT = 120;
const IMAGE_MAX_WIDTH = 200;

interface Props {
  alt: string;
  item: ListOption;
  onChange: (value: string) => void;
  value?: string;
}

export const ImageInputListItem: React.FC<Props> = ({
  alt,
  item,
  onChange,
  value,
}) => {
  const [styles] = useStyles();
  return (
    <ListItem
      item={item}
      onSelect={async () => {
        const result = await ImagePicker.launchImageLibraryAsync({
          allowsEditing: true,
          aspect: [IMAGE_MAX_WIDTH, IMAGE_HEIGHT],
          base64: true,
          mediaTypes: 'images',
          quality: 1,
        });

        if (!result.canceled) {
          // Return base64 so it can be saved in AsyncStorage
          onChange(`data:image/jpeg;base64,${result.assets[0].base64}`);
        }
      }}
      renderRightComponent={() =>
        value ? (
          <Image
            alt={alt}
            resizeMode="contain"
            source={{ uri: value }}
            style={styles.image}
          />
        ) : null
      }
      rightComponentStyle={styles.listItemImageContainer}
    />
  );
};

const useStyles = createStyles((theme) => ({
  image: {
    height: '100%',
    width: '100%',
  },
  listItemImageContainer: {
    borderColor: theme.colors.stroke,
    borderWidth: 1,
    height: IMAGE_HEIGHT,
    maxWidth: IMAGE_MAX_WIDTH,
    width: '100%',
  },
}));
